import React from "react";
import { SampleRequestListPage } from "../../SharedPages/SampleRequestListPage/SampleRequestListPage";

/**
 * The "Sample Requests" page that displays a list of sample requests.
 */
export const SellerSampleRequests = () => {
  return <SampleRequestListPage />;
};
